import React from 'react';
import {
	AssetViewsTextFilterContainer,
	type AssetViewsTextFilterContainerProps,
} from './AssetViewsTextFilter';

export type AssetViewsFiltersElement = HTMLDivElement;
export type AssetViewsFiltersRef = React.ForwardedRef<AssetViewsFiltersElement>;

export interface AssetViewsFiltersProps extends AssetViewsTextFilterContainerProps {}

export const AssetViewsFiltersPrimitive = React.forwardRef<
	AssetViewsFiltersElement,
	AssetViewsFiltersProps
>(({...props}, ref) => {
	return <AssetViewsTextFilterContainer ref={ref} {...props} />;
});
/**
 * `AssetViewsFilters` is a component that encapsulates filter functionality for the system groups list, supporting modular filter additions.
 */
export const AssetViewsFilters = AssetViewsFiltersPrimitive as (
	props: AssetViewsFiltersProps,
	ref: AssetViewsFiltersRef,
) => JSX.Element;

export default AssetViewsFilters;

export type AssetViewsFiltersContainerProps = AssetViewsFiltersProps;

export const AssetViewsFiltersContainer = React.forwardRef<
	AssetViewsFiltersElement,
	AssetViewsFiltersContainerProps
>((props, ref) => {
	return <AssetViewsFilters {...props} ref={ref} />;
});
